import ContactForm from "../components/ContactForm";
import {
  Building2,
  CheckCircle2,
  Mail,
  MapPin,
  MessageCircle,
  Zap,
} from "lucide-react";

const offices = [
  {
    type: "Head Office",
    city: "Delhi",
    address: "C-58, Shahpuri Tower, Janakpuri, Delhi - 110058",
    email: "ojmeetech@gmail.com",
  },
  {
    type: "Branch Office",
    city: "Jaipur",
    address: "Indra Bazar, Baba Harishchandra Marg, Pink City, Jaipur, Rajasthan 302001",
    email: "ojmeetech@gmail.com",
  },
];

const projectTypes = [
  "Website Development",
  "Mobile App",
  "ERP / HRMS",
  "CRM / Billing",
  "E-Commerce",
  "AI & Automation",
  "Cloud / API",
  "Custom Software",
];

export default function Contact() {
  return (
    <main className="w-full overflow-hidden">

      <section className="relative w-full px-4 py-20 sm:px-6 lg:py-28">
        <div className="pointer-events-none absolute left-1/2 top-0 -z-10 h-[600px] w-[900px] -translate-x-1/2 rounded-full bg-pink-600/10 blur-[160px]" />

        <div className="mx-auto max-w-7xl">
          <div className="grid gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:items-start">
            <div className="lg:sticky lg:top-28">
              <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-pink-400/20 bg-pink-400/5 px-5 py-2.5">
                <span className="text-[10px] font-bold uppercase tracking-[0.3em] text-pink-200">
                  Contact OjMee Technology
                </span>
              </div>

              <h1 className="text-3xl font-black leading-tight sm:text-5xl">
                Let&apos;s Build Your
                <br />

                <span className="bg-gradient-to-r from-pink-400 via-fuchsia-400 to-violet-400 bg-clip-text text-transparent">
                  Digital Future
                </span>
              </h1>

              <p className="mt-6 max-w-xl text-sm leading-8 text-slate-400 sm:text-base">
                Have a software idea, business challenge or an existing
                application that needs improvement? Tell us what you are
                looking to build and our team will help you explore the right
                technology solution.
              </p>

              <p className="mt-4 max-w-xl text-sm leading-8 text-slate-500">
                From websites and mobile applications to ERP, CRM, AI
                automation, cloud systems and custom enterprise software,
                OjMee Technology helps businesses turn requirements into
                reliable digital products.
              </p>

              <div className="mt-9">
                <a
                  href="mailto:ojmeetech@gmail.com"
                  className="group flex items-start gap-4 rounded-2xl border border-white/10 bg-white/[0.025] p-4 transition duration-300 hover:border-pink-400/25 hover:bg-white/[0.04]"
                >
                  <div className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-gradient-to-br from-pink-500/15 to-violet-500/15">
                    <Mail className="h-5 w-5 text-pink-300" />
                  </div>

                  <div className="min-w-0">
                    <p className="text-xs font-bold uppercase tracking-[0.15em] text-slate-500">
                      Email Us
                    </p>

                    <p className="mt-1 break-words text-sm font-bold text-slate-200 transition group-hover:text-pink-200">
                      ojmeetech@gmail.com
                    </p>

                    <p className="mt-1 text-xs leading-5 text-slate-600">
                      Send us your requirements, questions or project details.
                    </p>
                  </div>
                </a>
              </div>
            </div>

            <div className="relative">
              <div className="pointer-events-none absolute -inset-5 -z-10 rounded-[3rem] bg-gradient-to-r from-pink-500/10 to-violet-600/10 blur-3xl" />

              <div className="rounded-[2.5rem] border border-white/10 bg-white/[0.035] p-6 shadow-2xl shadow-black/20 backdrop-blur-xl sm:p-8 lg:p-10">
                <div className="mb-8">
                  <div className="flex items-center gap-3">
                    <div className="grid h-12 w-12 place-items-center rounded-2xl bg-gradient-to-br from-pink-500 to-violet-600 shadow-lg shadow-pink-500/20">
                      <MessageCircle className="h-5 w-5 text-white" />
                    </div>

                    <div>
                      <h2 className="text-2xl font-black">
                        Start a Conversation
                      </h2>

                      <p className="mt-1 text-xs text-slate-500">
                        Tell us about your project
                      </p>
                    </div>
                  </div>

                  <p className="mt-5 text-sm leading-7 text-slate-500">
                    Fill in the details below and share as much information as
                    possible. It will help us understand your requirements and
                    prepare the right direction for your project.
                  </p>
                </div>

                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="relative w-full border-y border-white/5 bg-white/[0.015] px-4 py-20 sm:px-6 lg:py-24">
        <div className="pointer-events-none absolute left-1/2 top-1/2 -z-10 h-[400px] w-[900px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-violet-600/[0.06] blur-[150px]" />

        <div className="mx-auto max-w-7xl">
          <div className="mx-auto max-w-3xl text-center">
            <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-pink-400/20 bg-pink-400/5 px-4 py-2">
              <Building2 className="h-4 w-4 text-pink-300" />

              <span className="text-[10px] font-bold uppercase tracking-[0.25em] text-pink-200">
                Our Offices
              </span>
            </div>

            <h2 className="text-3xl font-black sm:text-5xl">
              Find OjMee Technology
              <br />

              <span className="bg-gradient-to-r from-pink-400 via-fuchsia-400 to-violet-400 bg-clip-text text-transparent">
                Across Our Locations
              </span>
            </h2>

            <p className="mt-5 text-sm leading-8 text-slate-500 sm:text-base">
              Connect with OjMee Technology through our head office and branch
              locations for business, software development and technology
              service enquiries.
            </p>
          </div>

          <div className="mx-auto mt-12 grid max-w-5xl gap-5 md:grid-cols-2">
            {offices.map((office, index) => {
              const isHeadOffice = office.type === "Head Office";

              return (
                <div
                  key={office.city}
                  className={`group relative overflow-hidden rounded-[2rem] border p-6 transition duration-300 sm:p-7 ${
                    isHeadOffice
                      ? "border-pink-400/25 bg-gradient-to-br from-pink-500/[0.08] via-white/[0.025] to-violet-500/[0.06]"
                      : "border-white/10 bg-white/[0.025] hover:border-pink-400/20 hover:bg-white/[0.04]"
                  }`}
                >
                  <div className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-pink-500/[0.07] blur-3xl" />

                  <div className="relative flex items-start justify-between gap-4">
                    <div
                      className={`grid h-14 w-14 place-items-center rounded-2xl ${
                        isHeadOffice
                          ? "bg-gradient-to-br from-pink-500 to-violet-600 shadow-lg shadow-pink-500/20"
                          : "border border-white/10 bg-white/[0.05]"
                      }`}
                    >
                      <Building2
                        className={`h-6 w-6 ${
                          isHeadOffice ? "text-white" : "text-pink-300"
                        }`}
                      />
                    </div>

                    <span
                      className={`rounded-full border px-3 py-1.5 text-[9px] font-bold uppercase tracking-[0.18em] ${
                        isHeadOffice
                          ? "border-pink-400/20 bg-pink-400/10 text-pink-200"
                          : "border-violet-400/20 bg-violet-400/[0.07] text-violet-200"
                      }`}
                    >
                      {office.type}
                    </span>
                  </div>

                  <div className="relative mt-6">
                    <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-slate-600">
                      Office {String(index + 1).padStart(2, "0")}
                    </p>

                    <h3 className="mt-2 text-2xl font-black text-white">
                      {office.city}
                    </h3>

                    <p className="mt-1 text-xs font-semibold text-pink-300">
                      OjMee Technology
                    </p>
                  </div>

                  <div className="relative mt-6 border-t border-white/[0.07] pt-5">
                    <div className="flex items-start gap-3">
                      <div className="mt-0.5 grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-white/[0.04]">
                        <MapPin className="h-4 w-4 text-pink-300" />
                      </div>

                      <div>
                        <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-slate-600">
                          Address
                        </p>

                        <p className="mt-1.5 text-sm leading-6 text-slate-400">
                          {office.address}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="relative mt-5">
                    <div className="flex items-start gap-3">
                      <div className="mt-0.5 grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-white/[0.04]">
                        <Mail className="h-4 w-4 text-violet-300" />
                      </div>

                      <div className="min-w-0">
                        <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-slate-600">
                          Email
                        </p>

                        {office.email.includes("Add ") ? (
                          <p className="mt-1.5 break-words text-sm font-semibold text-slate-400">
                            {office.email}
                          </p>
                        ) : (
                          <a
                            href={`mailto:${office.email}`}
                            className="mt-1.5 block break-words text-sm font-semibold text-slate-300 transition hover:text-pink-300"
                          >
                            {office.email}
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="mt-8 text-center">
            <p className="text-xs leading-6 text-slate-600">
              Delhi serves as the Head Office of OjMee Technology.
              Jaipur operate as branch offices.
            </p>
          </div>
        </div>
      </section>

      <section className="w-full px-4 py-20 sm:px-6 lg:py-24">
        <div className="mx-auto max-w-7xl">
          <div className="mx-auto max-w-3xl text-center">
            <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-violet-400/20 bg-violet-400/5 px-4 py-2">
              <Zap className="h-4 w-4 text-violet-300" />

              <span className="text-[10px] font-bold uppercase tracking-[0.25em] text-violet-200">
                What Can We Build?
              </span>
            </div>

            <h2 className="text-3xl font-black sm:text-5xl">
              Tell Us What You
              <br />

              <span className="bg-gradient-to-r from-pink-400 to-violet-400 bg-clip-text text-transparent">
                Want To Create
              </span>
            </h2>

            <p className="mt-5 text-sm leading-8 text-slate-500 sm:text-base">
              Whether you are starting something new or improving an existing
              system, our team can work around your business requirements.
            </p>
          </div>

          <div className="mx-auto mt-12 grid max-w-5xl grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
            {projectTypes.map((item) => (
              <div
                key={item}
                className="group flex items-center gap-3 rounded-2xl border border-white/10 bg-white/[0.025] px-4 py-4 transition duration-300 hover:border-pink-400/25 hover:bg-white/[0.05]"
              >
                <CheckCircle2 className="h-4 w-4 shrink-0 text-pink-400/70 transition group-hover:text-pink-300" />

                <span className="text-xs font-semibold text-slate-400 group-hover:text-slate-300">
                  {item}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}